<template>
	<div>
		<!-- <div class="seatBox"></div> -->
		<div class="bgc">
			<div class="title" @click="backstage">应急后台管理系统</div>
			<el-dropdown @command="onUserClick">
				<div class="userBox">
					<img class="imgBig" src="@/assets/login-bg.jpg" alt="">
					<div class="nameCss">{{ userData.strName }}</div>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="logOut">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
import resetRouter from '@/router/resetRouter.js';
import {
	logout,
	goOut
} from "@/api/request/dahuaApi/dahua";
export default {
	name: '',
	data() {
		return {
			userData: {},
		}
	},
	created() {
		this.userData = JSON.parse(localStorage.getItem("userData"))
	},
	methods: {
		// 跳转首页大屏
		backstage() {
			localStorage.setItem("checkEmergencyF", 0)
			localStorage.setItem("checkEmergencyZ", 0)
			this.$router.replace({
				path: '/home'
			})
		},
		// 用户下拉菜单
		onUserClick(name) {
			if (name === 'logOut') {
				this.logOut()
			}
		},
		// 退出登录
		logOut() {
			this.$confirm('此操作将退出账号登录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				console.log("1111确定");
				logout()
				this.$message({
					type: 'success',
					message: '退出成功!'
				});
				this.$router.replace({
					path: '/'
				})
				localStorage.clear()
				resetRouter()

				this.$api.goOut().then((res) => {
					// logout()
					// this.$message({
					// 	type: 'success',
					// 	message: '退出成功!'
					// });
					// this.$router.replace({
					// 	path: '/'
					// })
					// localStorage.clear()
					// resetRouter()
				})
			}).catch(() => {

				this.$message({
					type: 'info',
					message: '取消'
				});
			});
		},
	}
}
</script>

<style scoped>
.bgc {
	width: 100%;
	height: 60px;
	background-color: #32373e;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	box-sizing: border-box;
	z-index: 99;
}

.title {
	font-size: 24px;
	color: #ffffff;
	cursor: pointer;
}

.userBox {
	display: flex;
	align-items: center;
	height: 60px;
	cursor: pointer;
}

.imgBig {
	width: 30px;
	height: 30px;
	border-radius: 50%;
}

.nameCss {
	margin-left: 10px;
	font-size: 16px;
	color: #ffffff;
}

.seatBox {
	width: 100%;
	height: 60px;
}
</style>
